import { useState, useEffect } from "react";
import { getNotes } from "http/fundLync/entityAndAddress.helper";

export const useFetchNotes = (entityId, dealId, refetch) => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchNotes = async () => {
      setLoading(true);
      try {
        let payload = {
          page: 1,
          limit: 10,
          columnName: "id",
          sortingOrder: "desc",
        };
        if (entityId != 0 && entityId) {
          payload.entityId = +entityId;
        }else{
          payload.dealId = +dealId;
        }
        const response = await getNotes(payload);
        if (response && response.data && response.data.data.length > 0) {
          // Assuming response.data is an array
          setNotes(response.data.data[0].notes);
        } else {
          setNotes([]);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNotes();
  }, [entityId, dealId, refetch]);

  return { notes, loading, error };
};
